import { render, staticRenderFns } from "./MetadadosExtensao.vue?vue&type=template&id=0765c290&lang=html"
import script from "./MetadadosExtensao.vue?vue&type=script&lang=js"
export * from "./MetadadosExtensao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports